function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23.431mm",
    height: "11.694mm",
    viewBox: "0 0 23.431 11.694",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-66.699 -123.51)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m253.59 468.31 40.094 40.094c1.487 1.487 3.8821 1.487 5.3691 0l40.094-40.094",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    style: {
      paintOrder: "markers fill stroke"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.6702081d2b6ad91d7e196c817aa5eeed.svg";
export { ForwardRef as ReactComponent };